module.exports = __webpack_public_path__ + "img/course02.28b2196b.png";